import script from "./deals-stages.vue?vue&type=script&setup=true&lang=js"
export * from "./deals-stages.vue?vue&type=script&setup=true&lang=js"

import "./deals-stages.vue?vue&type=style&index=0&id=3b865bd3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b865bd3"]])

export default __exports__